import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'empName',
      label: '业务员姓名',
      type: 'input',
      placeholder: '请输入业务员姓名'
    },
    {
      field: 'custName',
      label: '客户昵称',
      type: 'input',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'activateType',
      type: 'select',
      label: '激活类型',
      placeholder: '请选择激活类型',
      options:[
        { title: '逼单客户', value: 0 },
        { title: '定金客户', value: 1},
      ],
      filterable: true,
      clearable: true,
    },
    // {
    //   field: 'timeSlot',
    //   type: 'datepicker',
    //   label: '拉群时间段',
    //   otherOptions: {
    //     startPlaceholder: '开始时间',
    //     endPlaceholder: '结束时间',
    //     type: 'daterange',
    //     'value-format': 'YYYY-MM-DD',
    //     disabledDate: (date: Date) => {
    //       const sixMonthsAgo = new Date();
    //       sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    //       return date.getTime() < sixMonthsAgo.getTime();
    //     }
    //   }
    // },
    {
      field: 'sysDate',
      type: 'datepicker',
      label: '查询日期',
      otherOptions: {
        placeholder: '选择日期',
        type: 'date',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
